<template>
    <div>
        <div class="container" v-if="this.show">
            <ul class="nav nav-tabs pe-auto">
                <li class="nav-item" v-for="tab in this.tabs" :key="tab">
                    <a class="nav-link" :style="{ 'pointer-events': activeComponent === tab.id ? 'none' : 'auto' }"
                        :class="{ active: activeComponent === tab.id }" @click="changeActiveEvent(tab)">
                        {{ tab.label }}
                    </a>
                </li>
            </ul>
            <div>
                <div class="d-flex flex-row align-items-center justify-content-end gap-4 py-4">
                    <div class="d-flex flex-column justify-content-center align-items-center">
                        <div class="d-flex flex-row align-items-center gap-3">
                            <span class="fs-5">Season</span> 
                            <input type="number" class="form-control" v-model.number="this.selectedSeason" @change="this.getWinners()"/>
                        </div>
                    </div>
                </div>
            </div>
            <Spinner v-if="this.isLoading">Gettings Champions</Spinner>
            <div class="tab-content" v-else>
                <Transition name="fade" mode="out-in">
                    <component :is="activeComponent" :entity="this.data" :subEntity="this.subEntity" :key="this.data">
                    </component>
                </Transition>
            </div>
        </div>

        <div class="d-flex w-100 h-100 justify-content-center align-items-center" v-else>
            Please select Region and Server
        </div>
    </div>
</template>

<script>
    import Spinner from "@/components/Loaders/Spinner.vue"
    import brawler from "@/assets/icons/brawler.png"
    import shaman from "@/assets/icons/shaman.png"
    import swordsman from "@/assets/icons/swordsman.png"
    import archer from "@/assets/icons/archer.png"
    import overall from "@/assets/icons/w.png"
    import TagisLakas from "@/components/pages/TagisLakas.vue"
    import Hackathon from "@/components/pages/Hackathon.vue"
    import store from "node-back-client/src/store";
    import { api } from "../services/api";

    // import hackWinners from "../util/hackathonMockData.json"

    export default {
        name: 'Event Winners',
        data() {
            return {
                store: store,
                tabs: [
                    {
                        id: "TagisLakas",
                        label: "Tagis Lakas",
                        type: 0
                    },
                    {
                        id: "Hackathon",
                        label: "Hackathon",
                        type: 3
                    }
                ],
                activeComponent: "TagisLakas",
                data: {},
                selectedSeason: 6,
                selectedEvent: 0,
                isLoading: false,
                reslist:[],
                currentRequestId: 0,
                subEntity: {
                    displayContents: [],
                    heroList: {
                        overall: -1,
                        swordsman: 0,
                        archer: 1,
                        brawler: 2,
                        shaman: 3
                    },
                    icons: {
                        overall,
                        swordsman,
                        archer,
                        brawler,
                        shaman
                    }
                },
                show: false
            }
        },
        components: {
            TagisLakas, Hackathon, Spinner
        },
        methods: {
            async getWinners() {
                const requestId = ++this.currentRequestId;
                this.isLoading = true;
                let res;
                switch (this.selectedEvent) {
                    case 0: //PVP(tagis lakas)
                        this.data.topTen = [];
                        this.data.topClass = [];
                        res = await api.getMatchMakingRank(this.selectedSeason, this.selectedEvent, -1, 0, 10)
                        
                        res = res[store.custom.countryCode][store.custom.serverCode]?.Data
                        if (res != null) {
                            for (const top of res) {
                                let dt = {
                                    entity_name: top.entity_name,
                                    points: top.points,
                                    entity_id: top.entity_id,
                                    hero_id: -1
                                }
                                this.data['topTen'].push(dt)
                            }
                        }
                        for (const classname of Object.keys(this.subEntity.heroList)) {
                            if(classname!=='overall'){
                                res = await api.getMatchMakingRank(
                                    this.selectedSeason,
                                    this.selectedEvent,
                                    this.subEntity.heroList[classname],
                                    0,
                                    10
                                );
                                res = res[store.custom.countryCode]?.[store.custom.serverCode]?.Data[0]
                                if (res) {
                                    let entity_name = res.entity_name
                                    let entity_id = res.entity_id
                                    let points = res.points
                                    let hero_id = res.hero_id
                                    this.data["topClass"].push({ hero_id, entity_name, points, entity_id })
                                }
                            }
                        }
                        this.subEntity.displayContents = [
                            {
                                entityDataName: "topTen",
                                title: "Overall Top 10"
                            },
                            {
                                entityDataName: "topClass",
                                title: "Class Champions"
                            },
                        ]

                        break;

                    case 3: //Hackathon
                        this.data.champion = []
                        res = await api.getMatchMakingRank(this.selectedSeason, this.selectedEvent, -1, 0, 10)
                        this.reslist = res[store.custom.countryCode][store.custom.serverCode]?.Data
                        if(this.reslist){
                            for(const champ of this.reslist){
                                let memberlist = await store.custom.apis[store.custom.countryCode].guild.getGuildMembers(champ.entity_id, store.custom.regionserver);
                                this.data.champion.push({
                                    entity_name: champ.entity_name,
                                    entity_id: champ.entity_id,
                                    points: champ.points,
                                    members: memberlist?.members ?? []
                                })
                            }
                        }
        
                        this.subEntity.displayContents = [
                            {
                                entityDataName: "champion",
                                title: "Seasonal Champion"
                            },
                        ]

                        break;
                    // case 4: //PK
                    //     break;

                }
                if (requestId === this.currentRequestId) {
                    this.isLoading = false;
                }
            },
            async changeActiveEvent(event) {
                this.activeComponent = event.id
                this.selectedEvent = event.type
                await this.getWinners();
            },
            async changeSeason(inc) {
                if (inc === "down") {
                    if (this.selectedSeason > 1) {
                        this.selectedSeason--
                    }
                }
                else {
                    this.selectedSeason++
                }
                await this.getWinners();
            }
        },
        async mounted() {
            store.custom.callbacks.initWinners = async () => {
                if (store.custom.serverCode != 'sel-server' || store.custom.serverCode != "") {
                    this.show = true;
                    await this.getWinners();
                }
            };
            if (store.custom.isInit) {
                if (store.custom.serverCode != 'sel-server' && store.custom.serverCode != null) {
                    this.show = true;
                    await this.getWinners();
                }
                else {
                    this.show = false
                }
            }
        },
        async created() {


        },
        // async mounted() {
        //     if (store.custom.countryCode != 'sel-server' && store.custom.serverCode != 'sel-server') {
        //         this.show = true;
        //         await this.getWinners();
        //     }
        // }
    }
</script>

<style></style>